import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

export const Sidebarwrapper = styled(Box)`
  top: 0;
  right: ${props => props.right};
  z-index: 99;
  position: fixed;
  touch-action: none;
  display: ${props => props.display};
`

export const SidebarBox = styled(Box)`
  top: 0;
  right: ${props => props.right};
  z-index: 999;
  min-height: 100%;
  position: absolute;
  display: ${props => props.display};
`
